module.exports = __webpack_public_path__ + "img/dark-mud-decal-05.d83596f9.png";